import { graphqlClient } from "@/core/api/graphql/client";
import { notifyBrlCurrencyUpdateError } from "@/core/utilities/notifyBrlCurrencyUpdateError";
import mutationDocument from "./updateLanguageAndCurrency.graphql";
import type {
  InputUpdateLanguageAndCurrencyType,
  Mutations,
  MutationsUpdateLanguageAndCurrencyArgs,
} from "@/core/api/graphql/types";

export async function updateLanguageAndCurrency(
  languageAndCurrencyInput: InputUpdateLanguageAndCurrencyType,
): Promise<boolean | undefined> {
  try {
    const { data } = await graphqlClient.mutate<
      Required<Pick<Mutations, "updateLanguageAndCurrency">>,
      MutationsUpdateLanguageAndCurrencyArgs
    >({
      mutation: mutationDocument,
      variables: { command: languageAndCurrencyInput },
    });

    return data!.updateLanguageAndCurrency;
  } catch (error) {
    notifyBrlCurrencyUpdateError(error, languageAndCurrencyInput.currency);
    throw error;
  }
}
